export function DukareeModules() {
  return (
    <div className="relative w-full max-w-4xl h-[600px] mx-auto my-16">
      <h2 className="text-2xl font-semibold text-center mb-12">MODULES</h2>

      {/* Central Logo */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
        <img
          src="/images/dukaree/dukaree_logo_resized.png"
          alt="Dukaree Logo"
          className="w-32 h-32 rounded-full border-4 border-white shadow-lg"
        />
      </div>

      {/* Circular Modules */}
      {types.map((t, i) => {
        const angle = (360 / types.length) * i;
        const radius = 220; // distance from the center
        const x = radius * Math.cos((angle * Math.PI) / 180);
        const y = radius * Math.sin((angle * Math.PI) / 180);

        return (
          <div
            key={i}
            className="absolute w-40 text-center transform -translate-x-1/2 -translate-y-1/2 group cursor-pointer"
            style={{
              top: `calc(50% + ${y}px)`,
              left: `calc(50% + ${x}px)`,
            }}
          >
            <div className="bg-white p-4 rounded-xl shadow hover:shadow-xl transition transform hover:scale-105 relative overflow-hidden">
              <img
                src={t.icon}
                alt={t.title}
                className="w-16 h-16 mx-auto mb-2 rounded-full object-cover"
              />
              <h3 className="text-sm font-bold">{t.title}</h3>
              <p className="text-xs text-gray-600">{t.desc}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}

//Dukaree Modules
const types = [
  {
    title: "Van Sales",
    desc: "Easily capture sales data in the field with real-time syncing to the web portal.",
    icon: "/images/dukaree/VanSales.jpg.avif",
  },
  {
    title: "Order Taking",
    desc: "Manage and track stock levels to ensure you never run out of inventory.",
    icon: "/images/dukaree/OrderTaking.jpeg",
  },
  {
    title: "Merchandising",
    desc: "Access custom analytics to forecast sales and optimize distribution strategies.",
    icon: "/images/dukaree/Merchandising1.jpg.avif",
  },
  {
    title: "Stock",
    desc: "Monitor and evaluate the activities of your sales teams on the go.",
    icon: "/images/dukaree/Stock1.jpg.avif",
  },
  {
    title: "Cash and Bank",
    desc: "Generate automated reports to reduce manual data entry and improve decision-making.",
    icon: "/images/dukaree/CashandBank.jpg.avif",
  },
  {
    title: "Delivery",
    desc: "Understand and manage customer orders for better service delivery.",
    icon: "/images/dukaree/Delivery1.jpg.avif",
  },
];
